import { LitElement, html, svg } from 'lit';

export class IconBurger24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Tre horisontale streker</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 4h18M3 12h18M3 20h18"></path></svg>`; }
}
if (!customElements.get('f-icon-burger24', IconBurger24)) {
  customElements.define('f-icon-burger24', IconBurger24);
}